import type { ValidationConfig } from '../validationEngine/types';

export const RESERVE_SPLIT_MIN = 0;
export const RESERVE_SPLIT_MAX = 100;
export const RESERVE_SPLIT_RANGE_MESSAGE = 'Reserve Split must be between 0 and 100.';

// Inline only. Unlike the lender and cancellation fields, `reserveSplit` is not registered in
// `contractFieldConfig`, so a `contract` token here would never be evaluated. Claiming it would imply
// an out-of-range split blocks contracting, which it does not.
const INLINE_FLOW = 'default';

export const reserveValidationConfig: ValidationConfig = {
    reserveSplit: {
        rules: [
            {
                type: 'CUSTOM',
                flow: INLINE_FLOW,
                params: {
                    evaluator: (v: unknown) => {
                        if (v === undefined || v === null || v === '') return true;
                        const n = Number(v);
                        return !isNaN(n) && isFinite(n) && n >= RESERVE_SPLIT_MIN && n <= RESERVE_SPLIT_MAX;
                    }
                },
                messages: {
                    inline: RESERVE_SPLIT_RANGE_MESSAGE,
                    gcalert: RESERVE_SPLIT_RANGE_MESSAGE
                }
            }
        ]
    }
};
